import { Route, Router } from '@angular/router';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ColumnMode, SelectionType } from '@swimlane/ngx-datatable';
import { NgxSpinnerService } from 'ngx-spinner';
import { forkJoin } from 'rxjs';
import { DashboardApiService } from 'src/app/core/services/api/dashboard-api.service';
import { PrintService } from 'src/app/core/services/print.service';
import { DashboardData } from 'src/app/shared/models/dashboardData';
import { Event } from 'src/app/shared/models/events/event';
import { EventSearchParams } from 'src/app/shared/models/events/eventSearchParams';
import { CaseSession } from 'src/app/shared/models/hearings/caseSession';
import { SearchParams } from 'src/app/shared/models/searchParams';

@Component({
  selector: 'app-lawyer-dashboard',
  templateUrl: './lawyer-dashboard.component.html',
  styleUrls: ['./lawyer-dashboard.component.scss']
})
export class LawyerDashboardComponent implements OnInit {
  displayedEvents: Event[] = [];
  public eventParams: EventSearchParams = new EventSearchParams();

  public overdueHearingsCount = 0;
  public overdueTimesheetCount = 0;
  public overdueDeadlinesCount = 0;

  public overDueHearings: CaseSession[] = [];
  public overDueTimesheet = [];
  public overdueDeadlines = [];

  public overDueHearingsParams = new SearchParams();
  public overDueTimesheetParams = new SearchParams();
  public overDeadlineParams = new SearchParams();

  @ViewChild('hearingsTable') hearingsTable: any;
  @ViewChild('remindersTable') remindersTable: any;
  columnMode: ColumnMode;
  SelectionType = SelectionType;

  constructor(
    private dashboardApi: DashboardApiService,
    private spinner: NgxSpinnerService,
    private printService: PrintService,
    private router: Router
  ) {
    this.initLoad();
  }

  ngOnInit(): void { }

  initLoad() {
    this.spinner.show();
    const initLoad$ = forkJoin([
      this.dashboardApi.getDashboardData()
    ]);
    initLoad$.subscribe({
      next: value => {
        this.handleResults(value[0]);
      }, complete: () => {
        this.spinner.hide();
      }
    });
  }

  handleResults(r: DashboardData) {
    this.overdueTimesheetCount = r.count.timesheet;
    this.overdueDeadlinesCount = r.deadlines.count;
    this.overdueDeadlines = r.deadlines.results;
  }

  assignBadgeCounts(r) {
    this.overdueHearingsCount = r.overdue_hearings_count;
    this.overdueTimesheetCount = r.overdue_timesheet_count;
  }

  loadTabContent(e) {
    if (e.nextId === 'timesheet' && !this.overDueTimesheet.length) {
      this.getOverdueTimesheet();
    }
  }

  getOverdueTimesheet() {
    this.spinner.show();
    this.dashboardApi.getOverdueTimesheets(this.overDueTimesheetParams).subscribe(
      r => {
        this.spinner.hide();
        this.overDueTimesheet = this.overDueTimesheet.concat(r.results);
      }
    )
  }

  checkCreatedBy() {

  }

  toggleRemindersRow(row) {
    this.remindersTable.rowDetail.toggleExpandRow(row);
  }

  toggleHearingsRow(row) {
    this.hearingsTable.rowDetail.toggleExpandRow(row);
  }

  hearingTransactionColor(session: CaseSession) {
    const overdue = (new Date().getTime() - new Date(session.sessionDate).getTime()) / (1000 * 3600 * 24);
    return overdue > 7 ? 'bg-danger' : overdue > 5 ? 'bg-warning' : overdue >= 2 ? 'bg-success' : '';
  }

  printSession(session) {
    this.printService.data = {
      session,
    };
    this.printService.printDocument('case-session');
  }


  onSelectTimesheetRow({ selected }) {
    this.router.navigate(['files', selected[0].caseId, 'timesheet']);
  }

}
